import React from 'react';
import { Reveal } from './ui/Reveal';
import { BatteryWarning, BrainCircuit, TrendingDown } from 'lucide-react';
export function WhyDietsFail() {
  return <section className="py-24 bg-white" data-id="element-123">
      <div className="max-w-5xl mx-auto px-6" data-id="element-124">
        <Reveal data-id="element-125">
          <div className="text-center mb-16" data-id="element-126">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-brand-coral" data-id="element-127">
              ¿Por qué fallan las dietas tradicionales?
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-128">
              La ciencia es clara: restringir calorías de forma extrema no
              funciona a largo plazo. Esto es lo que realmente le pasa a tu
              cuerpo.
            </p>
          </div>
        </Reveal>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-129">
          <Reveal delay={0.1} data-id="element-130">
            <div className="text-center p-6" data-id="element-131">
              <div className="w-16 h-16 mx-auto bg-red-50 rounded-full flex items-center justify-center mb-6" data-id="element-132">
                <BatteryWarning className="w-8 h-8 text-red-400" data-id="element-133" />
              </div>
              <h3 className="text-xl font-bold mb-3" data-id="element-134">Modo Supervivencia</h3>
              <p className="text-gray-600 text-sm leading-relaxed" data-id="element-135">
                Cuando pasas hambre, tu cuerpo entra en alerta. Ralentiza tu
                metabolismo para ahorrar energía, haciendo que cada vez sea más
                difícil perder peso.
              </p>
            </div>
          </Reveal>

          <Reveal delay={0.2} data-id="element-136">
            <div className="text-center p-6" data-id="element-137">
              <div className="w-16 h-16 mx-auto bg-orange-50 rounded-full flex items-center justify-center mb-6" data-id="element-138">
                <BrainCircuit className="w-8 h-8 text-orange-400" data-id="element-139" />
              </div>
              <h3 className="text-xl font-bold mb-3" data-id="element-140">Ansiedad y Antojos</h3>
              <p className="text-gray-600 text-sm leading-relaxed" data-id="element-141">
                La restricción severa altera las hormonas del hambre (grelina y
                leptina), provocando atracones incontrolables y culpa constante.
              </p>
            </div>
          </Reveal>

          <Reveal delay={0.3} data-id="element-142">
            <div className="text-center p-6" data-id="element-143">
              <div className="w-16 h-16 mx-auto bg-brand-sand rounded-full flex items-center justify-center mb-6" data-id="element-144">
                <TrendingDown className="w-8 h-8 text-brand-forest" data-id="element-145" />
              </div>
              <h3 className="text-xl font-bold mb-3" data-id="element-146">Pérdida de Músculo</h3>
              <p className="text-gray-600 text-sm leading-relaxed" data-id="element-147">
                Las dietas rápidas suelen hacerte perder agua y masa muscular,
                no grasa. Al volver a comer normal, recuperas el peso (y más) en
                forma de grasa.
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>;
}